"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XMLHttpRequestState = void 0;
var XMLHttpRequestState;
(function (XMLHttpRequestState) {
    XMLHttpRequestState[XMLHttpRequestState["Completed"] = 4] = "Completed";
})(XMLHttpRequestState || (exports.XMLHttpRequestState = XMLHttpRequestState = {}));
